export const LEGACY_FIELDS = Object.freeze({

    NOTIFICATIONS: "notifications",

    ANNOUNCES: "announces",

    COMPLETED_ANNOUNCES: "announces_effectuees",

});